export default "__VITE_ASSET__CBq0TJ74__"